import { styled } from '@mui/material/styles'

/** Подпись колонки с иконкой тултипа */
export const HeadLabelWithTooltip = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  maxWidth: '100%',
}))
